import React from 'react';

export function NewZealand(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#00247D"/>
      <rect x="0" y="0" width="200" height="160" fill="#00247D"/>
      <line x1="0" y1="0" x2="200" y2="160" stroke="white" strokeWidth="22"/>
      <line x1="200" y1="0" x2="0" y2="160" stroke="white" strokeWidth="22"/>
      <line x1="0" y1="0" x2="200" y2="160" stroke="#CF142B" strokeWidth="14"/>
      <line x1="200" y1="0" x2="0" y2="160" stroke="#CF142B" strokeWidth="14"/>
      <rect x="85" y="0" width="30" height="160" fill="white"/>
      <rect x="0" y="65" width="200" height="30" fill="white"/>
      <rect x="91" y="0" width="18" height="160" fill="#CF142B"/>
      <rect x="0" y="71" width="200" height="18" fill="#CF142B"/>
      <polygon points="340,40 346,58 365,58 350,69 356,87 340,76 324,87 330,69 315,58 334,58" fill="#CC142B"/>
      <polygon points="420,100 424,112 437,112 427,120 431,132 420,124 409,132 413,120 403,112 416,112" fill="#CC142B"/>
      <polygon points="370,160 374,172 387,172 377,180 381,192 370,184 359,192 363,180 353,172 366,172" fill="#CC142B"/>
      <polygon points="440,50 443,60 453,60 445,66 448,76 440,70 432,76 435,66 427,60 437,60" fill="#CC142B"/>
    </svg>
  );
}
